import { render, staticRenderFns } from "./ChemicalsComponent.vue?vue&type=template&id=1363740c"
import script from "./ChemicalsComponent.vue?vue&type=script&lang=js"
export * from "./ChemicalsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports